const data = [
  {
    id: 1,
    img: "https://cdn.onesearch.com/lo/api/res/1.2/wWxAOdroqaFSInukFRSOqA--~B/YXBwaWQ9eWlzZWFyY2g7Zmk9Zml0O2dlPTAwNjYwMDtncz0wMEEzMDA7aD0yMzM7dz00MDA-/https://ds055uzetaobb.cloudfront.net/brioche/uploads/TvY8JiPVvOPqN1nhUDFL6d-Course-Logic-Reillustrated-1172-21754-irYAOI.png?width=400.cf.png",
    title: "Warmup puzzles",
    text: "Get started with some logic warmups.",
  },
  {
    id: 2,
    img: "https://cdn.onesearch.com/lo/api/res/1.2/R5Yy8LtgQdwmdov2.9jFpQ--~B/YXBwaWQ9eWlzZWFyY2g7Zmk9Zml0O2dlPTAwNjYwMDtncz0wMEEzMDA7aD0zNDc7dz00ODA-/https://ds055uzetaobb.cloudfront.net/brioche/uploads/TvY8JiPVvOPqN1nhUDFL6d-Course-Logic-Reillustrated-1571-95-OYBsYF.png?width=480.cf.png",
    title: "Truth Seeking",
    text: "Who or What is telling the truth.",
  },
  {
    id: 3,
    img: "https://cdn.onesearch.com/lo/api/res/1.2/2a72aRyreqHqfS7EOAKsPQ--~B/YXBwaWQ9eWlzZWFyY2g7Zmk9Zml0O2dlPTAwNjYwMDtncz0wMEEzMDA7aD02Mjg7dz0xMjAw/https://ds055uzetaobb.cloudfront.net/solvable_creative/pluspuzzle.png.cf.png",
    title: "Strategic deductions",
    text: "Stretch the information you,re given as far as it can go!",
  },
];
export default data;
